import React from 'react'
import { formatAmount, formatIntAmount } from '../../lib/formatAmountHandler'
import ListNumericInput from '../controls/ListNumericInput'

const RoznicaCITRZiSRow = props => {
  return (
    <div className="roznica-row">
      <span className="high-emphasis-body-1 name">{props.opis}</span>
      {props.readOnly ? (
        <>
          <span data-cy="kwotaA" className="high-emphasis-body-1 from">
            {props.czyKwotyWTysiacach
              ? formatIntAmount(props.kwotaRP)
              : formatAmount(props.kwotaRP, 2)}
          </span>
          <span className="high-emphasis-body-1 to">
            {props.czyKwotyWTysiacach
              ? formatIntAmount(props.kwotaRB)
              : formatAmount(props.kwotaRB, 2)}
          </span>
        </>
      ) : (
        <>
          <ListNumericInput
            placeholder="Rok poprzedni"
            name={props.nameA}
            value={props.kwotaRP}
            onValueChange={e =>
              props.aktualizujSumy(e, props.index, props.nameA)
            }
            czyKwotyWTysiacach={props.czyKwotyWTysiacach}
          />
          <ListNumericInput
            name={props.nameB}
            placeholder="Rok bieżący"
            value={props.kwotaRB}
            onValueChange={e =>
              props.aktualizujSumy(e, props.index, props.nameB)
            }
            czyKwotyWTysiacach={props.czyKwotyWTysiacach}
          />
        </>
      )}
    </div>
  )
}

export default RoznicaCITRZiSRow
